export const inputCls =
  "w-full h-11 px-3 rounded-md border border-zinc-300 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-zinc-900";
export const labelCls =
  "block text-xs font-semibold uppercase tracking-wider text-zinc-500 mb-1";
export const btnPrimary =
  "h-11 px-6 rounded-md bg-zinc-900 text-white text-sm font-semibold disabled:opacity-50";
export const btnGhost =
  "h-9 px-3 rounded-md border border-zinc-300 bg-white text-zinc-700 text-xs font-semibold";

export function Card({ title, desc, children, testid }) {
  return (
    <section className="bg-white border border-zinc-200 rounded-lg p-5 space-y-4" data-testid={testid}>
      <div>
        <h2 className="font-display font-semibold text-zinc-900">{title}</h2>
        {desc && <p className="text-xs text-zinc-500 mt-0.5">{desc}</p>}
      </div>
      {children}
    </section>
  );
}

export function ReadOnlyNote() {
  return (
    <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2"
      data-testid="readonly-note">
      Ruolo Sala: visualizzazione in sola lettura. Le modifiche richiedono un utente Admin o Manager.
    </p>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      {children}
    </div>
  );
}

export function Grid({ children }) {
  return <div className="grid sm:grid-cols-2 gap-4">{children}</div>;
}
